import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { SuperAdminAuthService } from '../super-admin/super-admin-auth.service';

/** Requests to superbeheer; authInterceptor and errorInterceptor leave these alone. */
export const isSuperAdminRequest = (url: string): boolean => url.includes('/super-admin/');

/**
 * Sends the superbeheer key with requests to /super-admin, and only with those. A 401 there means the key ran out
 * or was refused: back to the superbeheer login, and a beheer or member session in the same browser stays.
 */
export const superAdminInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isSuperAdminRequest(req.url) || req.url.includes('/super-admin/auth/')) {
    return next(req);
  }

  const superAdminAuth = inject(SuperAdminAuthService);
  const router = inject(Router);
  const key = superAdminAuth.getKey();
  const request = key === null ? req : req.clone({ setHeaders: { Authorization: `Bearer ${key}` } });

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        superAdminAuth.logout();
        router.navigateByUrl('/superadmin/inloggen');
      }

      return throwError(() => error);
    }),
  );
};
